// Shared enums / option lists / display metadata

export const STATUS_ORDER = [
  "NEW", "CONTACTED", "FOLLOW_UP", "NEGOTIATION", "OFFER", "DEAL_DONE", "LOST",
];

export const STATUS_META = {
  NEW: {
    label: "New",
    badge: "bg-status-new/10 text-status-new ring-1 ring-inset ring-status-new/20",
    dot: "bg-status-new", bar: "bg-status-new", solid: "bg-status-new text-white",
  },
  CONTACTED: {
    label: "Contacted",
    badge: "bg-status-contacted/10 text-status-contacted ring-1 ring-inset ring-status-contacted/20",
    dot: "bg-status-contacted", bar: "bg-status-contacted", solid: "bg-status-contacted text-white",
  },
  FOLLOW_UP: {
    label: "Follow-up",
    badge: "bg-status-followup/10 text-status-followup ring-1 ring-inset ring-status-followup/20",
    dot: "bg-status-followup", bar: "bg-status-followup", solid: "bg-status-followup text-white",
  },
  NEGOTIATION: {
    label: "Negotiation",
    badge: "bg-status-negotiation/10 text-status-negotiation ring-1 ring-inset ring-status-negotiation/20",
    dot: "bg-status-negotiation", bar: "bg-status-negotiation", solid: "bg-status-negotiation text-white",
  },
  OFFER: {
    label: "Offer",
    badge: "bg-status-offer/10 text-status-offer ring-1 ring-inset ring-status-offer/20",
    dot: "bg-status-offer", bar: "bg-status-offer", solid: "bg-status-offer text-white",
  },
  DEAL_DONE: {
    label: "Deal Done",
    badge: "bg-status-dealdone/10 text-status-dealdone ring-1 ring-inset ring-status-dealdone/20",
    dot: "bg-status-dealdone", bar: "bg-status-dealdone", solid: "bg-status-dealdone text-white",
  },
  LOST: {
    label: "Lost",
    badge: "bg-status-lost/10 text-status-lost ring-1 ring-inset ring-status-lost/20",
    dot: "bg-status-lost", bar: "bg-status-lost", solid: "bg-status-lost text-white",
  },
};

export function statusMeta(s) {
  return STATUS_META[s] || STATUS_META.NEW;
}

// Deal processing status option lists
export const DOC_STATUSES = ["Pending", "Partially Received", "Received"];
export const APPROVAL_STATUSES = ["Pending", "Under Review", "Approved", "Rejected"];
export const PAYMENT_STATUSES = ["Pending", "Paid"];
export const COD_STATUSES = ["Pending", "Issued"];

// Tint style for a generic processing value
export function processingTone(value) {
  const good = ["Received", "Approved", "Paid", "Issued", "Done"];
  const warn = ["Partially Received", "Under Review", "Pending"];
  const bad = ["Rejected"];
  if (good.includes(value)) return "bg-success/10 text-success ring-1 ring-inset ring-success/20";
  if (bad.includes(value)) return "bg-destructive/10 text-destructive ring-1 ring-inset ring-destructive/20";
  if (warn.includes(value)) return "bg-warning/10 text-warning ring-1 ring-inset ring-warning/20";
  return "bg-muted text-muted-foreground";
}

export const FUEL_TYPES = ["Petrol", "Diesel", "CNG", "Electric", "Hybrid", "LPG"];
export const CONDITIONS = ["Excellent", "Good", "Average", "Below Average", "Needs Work"];
export const ALLOY_OPTIONS = ["Yes", "No"];

export const YEARS = (() => {
  const now = new Date().getFullYear();
  const arr = [];
  for (let y = now; y >= now - 25; y--) arr.push(String(y));
  return arr;
})();

export const OEM_BRANDS = [
  "Maruti Suzuki", "Hyundai", "Tata Motors", "Mahindra", "Kia", "Toyota",
  "Honda", "Renault", "Volkswagen", "Skoda", "MG", "Nissan", "Ford", "Other",
];

export const LOST_REASONS = [
  "Price mismatch", "Sold elsewhere", "Not responding", "Vehicle not available",
  "Condition issue", "Owner changed mind", "Other",
];
